import { Action, State, StateContext, Store } from "@ngxs/store";
import { Audit, AuditStateModel } from "./audit.model";
import { inject, Injectable } from "@angular/core";
import { AuditService } from "../audit.service";
import { GetAudits } from "./audit.actions";
import { catchError, tap } from "rxjs";
import { OnSetSharedGridRowData } from "app/modules/shared/ag-grid/shared-grid-state/shared-grid.actions";
import { ShowToastrAlert } from "app/modules/shared-state/shared.actions";

@State<AuditStateModel>({
  name: 'audits',
  defaults: {
    audits: [],
  }
})

@Injectable()
export class AuditState {
  private _store = inject(Store);
  private _auditService = inject(AuditService);

  @Action(GetAudits)
  getAudits(ctx: StateContext<AuditStateModel>, { payload }: GetAudits) {
    return this._auditService.getAllAudits().pipe(
      catchError((error) => {
        console.error('Error getting audits:', error);
        ctx.dispatch(new ShowToastrAlert({
          showToast: true,
          toastrType: 'error',
          messageTitle: 'Error',
          messageBody: `Error error getting audits: ${error.error.message ? error.error.message.message : `Error connecting server`}`,
          position: 'toast-top-center'
        }));
        throw error;
      }),
      tap((audits: Audit[]) => {
        ctx.dispatch(new OnSetSharedGridRowData({ reload: true, payload: audits, gridUUID: payload.gridUUID }));
      })
    );
  }


}